import React from 'react';
import MyCustomLogoFull from './zapay-icon.png';

const LogoIcon = () => {
  return <img src={MyCustomLogoFull} style={{ width: '158px', height: '123px' }}/>;
};

export default LogoIcon;
